module.exports = __webpack_public_path__ + "static/dawnbringer_cleric_mtg_clb-bccb8505c6d709b72a6a261d26488b32.jpg";